import { render, staticRenderFns } from "./BasicInfoStep.vue?vue&type=template&id=506eb6a3&scoped=true"
import script from "./BasicInfoStep.vue?vue&type=script&lang=js"
export * from "./BasicInfoStep.vue?vue&type=script&lang=js"
import style0 from "./BasicInfoStep.vue?vue&type=style&index=0&id=506eb6a3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "506eb6a3",
  null
  
)

export default component.exports